export const ARTICLE_BLUEPRINT_AFTER = {
  RECOMMENDATIONS: 'RECOMMENDATIONS',
}
